<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content">
        <div class="operations">
          <div class="filters">
            <el-form :inline="true" label-width="80px" label-position="left" style="margin-left: 30px">
              <el-form-item :label="$t('SeaExport.InnerContractNo')">
                <el-input v-model="condition.innerContractNo" style="width: 300px" />
              </el-form-item>
            </el-form>
          </div>
          <div class="triggers">
            <div>
              <el-button type="primary" @click="toQuery(condition)">{{ $t('common.btn.query') }}</el-button>
              <el-button type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
              <el-button :disabled="!selectedNode" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
              <el-button type="danger" @click="toBatchDelete">{{ $t('common.btn.delete') }}</el-button>
              <el-button type="primary" @click="toBatchUpdateActive(true)">{{ $t('CargoMsg.Cargo_Enable') }}</el-button>
              <el-button type="danger" @click="toBatchUpdateActive(false)">{{ $t('CargoMsg.Cargo_Disable') }}</el-button>
            </div>
          </div>
        </div>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="100403"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            config-module="100403"
            :total="total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="toQuery()"
          />
        </div>
      </div>
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="450px"
      :close-on-click-modal="false"
    >
      <el-form label-width="80px" label-position="right">
        <el-form-item :label="$t('SeaExport.InnerContractNo')">
          <el-input v-model="editDialog.form.innerContractNo" :disabled="editDialog.form.used" />
        </el-form-item>
        <el-form-item :label="$t('Message.ApplicableRoute')">
          <cargo-advance-select
            :select-type="TYPE_NAMES.basic_data_Region"
            filterable
            :multiple="true"
            :default-multiple-value="toArray(editDialog.form.regions)"
            style="width:100%;"
            @parentCallBack="p=>{editDialog.form.regions=toTxt(p.value)}"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="save">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { InnerContractNo } from '@/class/model/mdm/InnerContractNo'
import { query, save, batchUpdateActive, batchDelete } from '@/api/mdm/innerContractNo'

export default {
  name: 'InnerContractNo',
  components: { cargoAdvanceSelect },
  data() {
    return {
      TYPE_NAMES,
      condition: {
        innerContractNo: ''
      },
      filter: {
        innerContractNo: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        suppressRowClickSelection: true,
        onRowDataChanged: event => {
          event.api.clearFocusedCell()
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onSortChanged: event => {
          if (this.selectedNode) {
            event.api.setFocusedCell(this.selectedNode.rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('SeaExport.Select'),
          checkboxSelection: true,
          width: 100,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        }, {
          headerName: this.$t('SeaExport.InnerContractNo'),
          field: 'innerContractNo',
          width: 100
        }, {
          headerName: this.$t('Message.ApplicableRoute'),
          field: 'regions',
          width: 200,
          valueFormatter: params => {
            if (params.value) {
              const arr = this.toArray(params.value)
              for (let i = 0; i < arr.length; ++i) {
                arr[i] = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Region, 'code', arr[i], 'name')
              }
              return arr.join(',')
            }
            return ''
          }
        }, {
          headerName: this.$t('Message.IsEnable'),
          field: 'active',
          width: 100,
          valueFormatter: params => {
            return params.value ? this.$t('Message.Yes') : this.$t('Message.No')
          }
        }, {
          headerName: this.$t('Message.ContractNoUseState'),
          field: 'used',
          width: 150,
          valueFormatter: params => {
            return params.value ? this.$t('CargoMsg.Cargo_Used') : this.$t('Message.NotUse')
          }
        }
      ],
      rowData: [],
      selectedNode: null,
      gridApi: null,
      editDialog: {
        visible: false,
        title: '',
        form: {}
      }
    }
  },
  methods: {
    toQuery(condition) {
      if (condition) {
        Object.assign(this.filter, condition)
        this.filter.pageNum = 1
      }
      query(this.filter).then(res => {
        this.rowData = res.data.list
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.total = Number(res.data.total)
      })
    },
    toArray(txt) {
      if (txt) {
        return txt.split(',')
      }
      return []
    },
    toTxt(strs) {
      if (strs && strs.length > 0) {
        return strs.join(',')
      }
      return ''
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.title = this.$t('Message.NewInnerContractNo')
        this.editDialog.form = new InnerContractNo().fillDefaultValue().getData()
        this.editDialog.form.used = false
      } else {
        this.editDialog.title = this.$t('Message.EditInnerContractNo')
        this.editDialog.form = { ...this.selectedNode.data }
      }
      this.editDialog.visible = true
    },
    save() {
      const form = this.editDialog.form
      if (!form.innerContractNo) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + ' ' + this.$t('SeaExport.InnerContractNo'))
        return
      }
      const loading = getLoading4Cxt(this)
      save(form).then(res => {
        this.editDialog.visible = false
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        if (!form.uuid) {
          this.filter.pageNum = 1
        }
        this.toQuery()
      }).finally(() => {
        loading.close()
      })
    },
    toBatchDelete() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('Message.AreYouSureToCancelThisData'), this.$t('Message.Confirm'), {
        confirmButtonText: this.$t('Message.Yes'),
        cancelButtonText: this.$t('Message.No'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const keys = []
        for (const row of rows) {
          if (row.used) {
            this.$message.warning(this.$t('Message.HasBeenUsedAndCannotBeDeleted'))
            return
          }
          keys.push(row.uuid)
        }
        const loading = getLoading4Cxt(this)
        batchDelete(keys).then(res => {
          this.$message.success(this.$t('Message.DeleteSuccessfully'))
          this.filter.pageNum = 1
          this.toQuery()
        }).finally(() => {
          loading.close()
        })
      }).catch(() => { })
    },
    toBatchUpdateActive(active) {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const keys = Array.from(rows, p => p.uuid)
      const loading = getLoading4Cxt(this)
      batchUpdateActive(keys, active).then(res => {
        this.$message.success(this.$t('Message.OperationSuccessfully'))
        this.toQuery()
      }).finally(() => {
        loading.close()
      })
    }
  }
}
</script>

<style scoped lang="scss">
#app .app-main-content ::v-deep {
  .el-dialog {
    .el-form-item__content {
      width: 300px;
    }
  }
}
</style>
